<template>
  <v-btn color="secondary" @click="refresh" :disabled="refreshing">
    <v-icon>refresh</v-icon>
    <span>Recargar</span>
  </v-btn>
</template>

<script>
import filter_rq from './filter_rq';
export default {
  mixins: [ filter_rq ],
  props:['ex_refresh','post_refresh'],
  data(){
    return {
      refreshing:false,
      reset_on_value_change: true,
      filter_rq_type:['>'],
    }
  },
  watch:{
    ex_refresh(v){ if (v) this.refresh() },
    refreshing(v){if (!v) this.$emit('update:ex_refresh', false)}
  },
  methods: {
    set_model(){},
    refresh() {
      this.refreshing = true;
      this.get_rq({}/* ex_f */)
        .then(r => {
          this.refreshing = false;
          if (this.post_refresh) this.post_refresh(r);
          return r
        });
    },
    then_get_rows(r) { return r },
  },
};
</script>
